export enum GenderType {
    M,
    F
}